import type { FC, ReactNode } from 'react'
import type { ButtonLegacy } from '@/components/ui/button-legacy'
import { Container } from '@/components/ui/container'
import { IconContainer } from '@/components/ui/icon-container'

interface ErrorBoxProps {
	cta?: ReturnType<typeof ButtonLegacy>
	icon: ReactNode
	title: string
}

export const ErrorBox: FC<ErrorBoxProps> = ({ cta, icon, title }) => {
	return (
		<Container className='flex items-center justify-center' fullHeight>
			<div className='flex max-w-[1024px] flex-col items-center justify-center gap-6'>
				<IconContainer>{icon}</IconContainer>
				<h1 className='text-center font-semibold text-3xl text-neutral-900'>
					{title}
				</h1>
				{cta}
			</div>
		</Container>
	)
}

ErrorBox.displayName = 'ErrorBox'
